import Hudromesophytic from "../assets/images/hydromesophytic_swamp_forest.jpg";
import MesicPrarie from "../assets/images/mesic_prairie.jpg";

interface GalleryType {
  name: string;
  image: string;
}

export const BeautyGalleryList: GalleryType[] = [
  {
    name: "Mesic Prairie",
    image: MesicPrarie,
  },
  {
    name: "Hydromesophytic Swamp Forest",
    image: Hudromesophytic,
  },
];

export type { GalleryType };
